module.exports = __webpack_public_path__ + "img/hotel-30.76c7a264.jpeg";